import {
  computed,
  ref,
  toRef,
} from "vue";

import AHttpAPI from "aloha-vue/src/compositionAPI/AHttpAPI";
import PuxTablePlugin, {
  tablePluginOptions,
} from "../plugin/PuxTablePlugin";

import EventBus from "aloha-vue/src/utils/EventBus";
import {
  cloneDeep,
  findIndex,
  forEach, get,
  isNil,
  isUndefined,
  map,
  orderBy,
} from "lodash-es";

export default function MultipleActionsAPI(props, {
  appliedModelFilters = ref({}),
  mainModelFilters = ref({}),
  modelSortLocal = ref(undefined),
  reloadData = () => {},
  useUrlParametersSorting = computed(() => false),
  viewCurrent = ref(undefined),
}) {
  const multipleActions = toRef(props, "multipleActions");
  const url = toRef(props, "url");
  const urlParams = toRef(props, "urlParams");

  const isLoadingMultipleActions = ref(undefined);
  const isMultipleActionWorkflow = ref(undefined);
  const massActionConfig = ref([]);
  const massActionConfigActive = ref(undefined);
  const massenstatuswechselFromResponse = ref(undefined);
  const urlParamsMultipleAction = ref({});
  const workflowfolgen = ref([]);
  // const multipleActionsPropsAndFromAPI = ref([]);

  const {
    checkPermissionsSync,
  } = PuxTablePlugin.PermissionAPI();

  const urlParametersLocal = computed(() => {
    const URL_PARAMETERS = {
      ...urlParams.value,
      ...appliedModelFilters.value,
      ...mainModelFilters.value,
    };
    if (useUrlParametersSorting.value) {
      URL_PARAMETERS.ordering = modelSortLocal.value;
    }
    const VIEW_URL_PARAMS = get(viewCurrent.value, "urlParams") || {};

    return {
      ...URL_PARAMETERS,
      ...VIEW_URL_PARAMS,
    };
  });

  const updateMultipleActionsFromAPI = configForCurrentTable => {
    if (configForCurrentTable?.massactions) {
      massActionConfig.value = orderBy(configForCurrentTable.massactions, ["tcma_prio"]);
    }
  };

  const updateMultipleActionsFromResponse = ({ response } = {}) => {
    massenstatuswechselFromResponse.value = response.massenstatuswechsel;
    if (response.workflowfolgen) {
      workflowfolgen.value = response.workflowfolgen;
    } else {
      workflowfolgen.value = [];
    }
  };

  const {
    getListHttp,
  } = AHttpAPI();

  const loadAllePks = arg => {
    isLoadingMultipleActions.value = true;
    const ARGUMENTS = cloneDeep(arg);
    const URL_PARAMS = {
      ...urlParametersLocal.value,
      fields: arg.action.fields || [
        "pk",
      ],
      limit: 100000,
    };
    getListHttp({
      url: url.value,
      urlParams: URL_PARAMS,
    }).then(
      response => {
        ARGUMENTS.rows = response;
        arg.action.callbackLocal(ARGUMENTS);
      }
    ).finally(() => {
      isLoadingMultipleActions.value = false;
    });
  };

  const onMultipleActions = (arg = {}) => {
    isLoadingMultipleActions.value = false;
    if (arg.areAllRowsSelected) {
      if (tablePluginOptions.value.global.project === "pvp") {
        loadAllePks(arg);
      } else {
        arg.pks = map(arg.rows, "pk");
        arg.urlParametersLocal = urlParametersLocal.value;
        arg.action.callbackLocal(arg);
      }
    } else {
      arg.pks = map(arg.rows, "pk");
      arg.action.callbackLocal(arg);
    }
  };

  const multipleActionsComputed = computed(() => {
    const MULTIPLE_ACTIONS = cloneDeep(multipleActions.value || []);
    forEach(MULTIPLE_ACTIONS, action => {
      if (isUndefined(action.isAllRowsSelected) && !isUndefined(tablePluginOptions.value.global.isAllRowsSelected)) {
        action.isAllRowsSelected = tablePluginOptions.value.global.isAllRowsSelected;
      }
      action.callbackLocal = action.callback;
      action.callback = onMultipleActions;
    });

    forEach(massActionConfig.value, actionConfig => {
      if (!isNil(actionConfig.tcma_permission) &&
        !checkPermissionsSync({
          perm: actionConfig.tcma_permission,
        })) {
        return;
      }
      actionConfig.callback = ({ rows }) => {
        massActionConfigActive.value = cloneDeep(actionConfig);
        massActionConfigActive.value.rows = rows;
        massActionConfigActive.value.close = ({ status = false }) => {
          if (status && massActionConfigActive.value.tcma_reload_on_finish) {
            // this.updateData(); TODO: Ilia
            EventBus.$emit(`cancelMassActions${ this.optionsClone.id }`, { status });
          }
          massActionConfigActive.value = undefined;
        };
      };
      const INDEX = findIndex(MULTIPLE_ACTIONS, ["tcma_id", actionConfig.tcma_id]);
      const actionConfigTemp = cloneDeep(actionConfig);
      actionConfigTemp.text = actionConfig.tcma_label;
      actionConfigTemp.title = actionConfig.tcma_title;
      actionConfigTemp.icon = actionConfig.tcma_icon;
      actionConfigTemp.class = actionConfig.tcma_css;
      actionConfigTemp.type = "button";
      if (isUndefined(actionConfigTemp.isAllRowsSelected) && !isUndefined(tablePluginOptions.value.global.isAllRowsSelected)) {
        actionConfigTemp.isAllRowsSelected = tablePluginOptions.value.global.isAllRowsSelected;
      }
      if (INDEX !== -1) {
        MULTIPLE_ACTIONS.splice(INDEX, 1, actionConfigTemp);
      } else {
        MULTIPLE_ACTIONS.push(actionConfigTemp);
      }
    });

    if (massenstatuswechselFromResponse.value) {
      forEach(cloneDeep(massenstatuswechselFromResponse.value), action => {
        const INDEX = findIndex(MULTIPLE_ACTIONS, ["pk", action.pk]);
        action.text = action.msw_kbez;
        action.type = "button";
        if (isUndefined(action.isAllRowsSelected) && !isUndefined(tablePluginOptions.value.global.isAllRowsSelected)) {
          action.isAllRowsSelected = tablePluginOptions.value.global.isAllRowsSelected;
        }
        action.callbackLocal = action.callback;
        action.callback = onMultipleActions;
        if (action.msw_kbez) {
          action.slot = true;
        }
        if (INDEX !== -1) {
          MULTIPLE_ACTIONS.splice(INDEX, 1, action);
        } else {
          MULTIPLE_ACTIONS.push(action);
        }
      });
    }

    return MULTIPLE_ACTIONS;
  });

  const toggleMultipleActions = ({ action, isActive } = {}) => {
    if (isActive) {
      if (action.slot) {
        isMultipleActionWorkflow.value = true;
        urlParamsMultipleAction.value = action.aufgabe ?
          {
            msw: action.aufgabe,
          } :
          {};
        reloadData();
        return;
      }
    } else if (action?.slot) {
      urlParamsMultipleAction.value = {};
      reloadData();
    }
    isMultipleActionWorkflow.value = false;
  };


  return {
    isLoadingMultipleActions,
    massActionConfigActive,
    multipleActionsComputed,
    toggleMultipleActions,
    updateMultipleActionsFromAPI,
    updateMultipleActionsFromResponse,
    urlParamsMultipleAction,
    workflowfolgen,
  };
}
